import React, { useState } from "react";
import { motion } from "framer-motion";
import { Bell, Send, CheckCircle, Clock } from "lucide-react";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "System Maintenance",
      message:
        "The system will be under maintenance on Sunday from 2 AM to 4 AM.",
      recipient: "All Users",
      time: "2 hours ago",
      status: "Sent",
    },
    {
      id: 2,
      title: "Exam Result Declared",
      message: "JEE Mains Mock Test 3 results are now live.",
      recipient: "Batch A - Morning",
      time: "5 hours ago",
      status: "Sent",
    },
  ]);

  return (
    <div className="min-h-screen bg-gray-900 p-6">
      <motion.div
        className="max-w-7xl mx-auto space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl shadow-lg shadow-indigo-500/20">
                <Bell className="w-7 h-7 text-white" />
              </div>
              <h1 className="text-4xl font-bold bg-gradient-to-br from-indigo-400 to-purple-400 bg-clip-text text-transparent">
                Notifications
              </h1>
            </div>
            <p className="text-gray-400 mt-2">
              Send push notifications and alerts
            </p>
          </div>

          <button className="flex items-center gap-2 px-6 py-3 bg-gradient-to-br from-indigo-600 to-purple-600 text-white rounded-lg hover:shadow-lg hover:shadow-indigo-500/20 transition-all font-semibold">
            <Send className="w-5 h-5" />
            Send Notification
          </button>
        </div>

        {/* Content */}
        <div className="bg-gray-800 rounded-2xl border border-gray-700 overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-gray-900 border-b border-gray-700">
              <tr>
                <th className="px-6 py-4 text-gray-400 font-semibold uppercase text-xs">
                  Title
                </th>
                <th className="px-6 py-4 text-gray-400 font-semibold uppercase text-xs">
                  Message
                </th>
                <th className="px-6 py-4 text-gray-400 font-semibold uppercase text-xs">
                  Recipient
                </th>
                <th className="px-6 py-4 text-gray-400 font-semibold uppercase text-xs">
                  Time
                </th>
                <th className="px-6 py-4 text-gray-400 font-semibold uppercase text-xs">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {notifications.map((notif) => (
                <tr
                  key={notif.id}
                  className="hover:bg-gray-900/50 transition-colors"
                >
                  <td className="px-6 py-4 text-white font-medium">
                    {notif.title}
                  </td>
                  <td className="px-6 py-4 text-gray-400 text-sm max-w-xs truncate">
                    {notif.message}
                  </td>
                  <td className="px-6 py-4">
                    <span className="bg-gray-700 text-gray-300 px-3 py-1 rounded-full text-xs">
                      {notif.recipient}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-500 text-sm flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    {notif.time}
                  </td>
                  <td className="px-6 py-4">
                    <span className="flex items-center gap-1 text-green-400 text-sm font-medium">
                      <CheckCircle className="w-4 h-4" />
                      {notif.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  );
};

export default NotificationsPage;
